import { presentationApi, type FiltresSelections } from '../../../api/presentation.js';
import { estErreurReseau } from '../../../api/errors.js';
import type { AppelApi } from '../../../api/client.js';
import type { PorteeFile } from '../../stand/fileHorsLigne.js';
import { magasinsPresentation } from './index.js';

export async function listerSelectionsPresentation(
  portee: PorteeFile,
  filtres: FiltresSelections,
  appel: AppelApi,
) {
  if (navigator.onLine) {
    try {
      return await presentationApi.lister(portee.galerieSlug, filtres, appel);
    } catch (erreur) {
      if (!estErreurReseau(erreur)) throw erreur;
    }
  }
  const selections = [];
  for (const magasin of magasinsPresentation()) {
    for (const preparation of await magasin.lister(portee)) {
      const charge = await magasin.lire(portee, preparation.selectionId);
      if (charge) selections.push(charge.charge.selection);
    }
  }
  appel.signal?.throwIfAborted();
  const filtrees = selections.filter(
    (selection) =>
      (filtres.archivee === undefined || selection.archivee === filtres.archivee) &&
      (!filtres.contactId || selection.contactId === filtres.contactId),
  );
  const page = filtres.page ?? 1;
  const parPage = filtres.parPage ?? 20;
  return {
    selections: filtrees.slice((page - 1) * parPage, page * parPage),
    pagination: {
      page,
      parPage,
      total: filtrees.length,
      pages: Math.ceil(filtrees.length / parPage),
    },
  };
}
